import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import logo from './Logo.jpg';
import AOS from 'aos';
import 'aos/dist/aos.css';

function ThankYou() {
    return (
        <div style={{ textAlign: 'center', padding: '100px 20px', fontFamily: "'Bebas Neue', sans-serif" }}>
            <h1 style={{ fontSize: '40px', color: '#007ABD' }}>Thank You!</h1>
            <p style={{ fontSize: '22px', color: '#000' }}>Your repair request has been submitted successfully.</p>
        </div>
    );
}

function MainPage() {
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        AOS.init({ duration: 800, once: true });
    }, []);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setMenuOpen(false);
        }
    };

    return (
        <>
            <nav style={navStyle}>
                <div style={floatingMenuWrapper}>
                    <button onClick={() => setMenuOpen(!menuOpen)} style={menuToggleStyle}>≡</button>
                    {menuOpen && (
                        <div style={dropdownMenuStyle}>
                            <button onClick={() => scrollToSection('services')} style={dropdownBtnStyle}>Services</button>
                            <button onClick={() => scrollToSection('why')} style={dropdownBtnStyle}>Why Us</button>
                            <button onClick={() => scrollToSection('contact')} style={dropdownBtnStyle}>Contact</button>
                            <button onClick={() => scrollToSection('prices')} style={dropdownBtnStyle}>Prices</button>
                            <a href="mailto:monroe@a1cellphonesurgeons.com?subject=Request%20Repair" style={dropdownLinkStyle}>Request Repair</a>
                        </div>
                    )}
                </div>
            </nav>

            <main
                className="App"
                style={{
                    fontFamily: "'Bebas Neue', sans-serif",
                    backgroundColor: '#FA0057',
                    color: '#000',
                    minHeight: '100vh',
                    paddingTop: '100px',
                }}
            >
                <div style={logoWrapperStyle} data-aos="fade-down">
                    <img src={logo} alt="Cellphone Surgeons Logo" style={logoStyle} />
                </div>

                <section id="services" style={sectionStyle} data-aos="fade-up">
                    <h2 style={sectionHeader}>Our Services</h2>
                    <p style={lineStyle}>Cellphone & iPad Repairs</p>
                    <p style={lineStyle}>Computer & Laptop Repairs</p>
                    <p style={lineStyle}>Tablet Repairs</p>
                    <p style={lineStyle}>Certified Device Sales</p>
                    <p style={lineStyle}>📦 Pickup & Delivery — We'll come to you and drop off when done</p>
                    <p style={lineStyle}>🚗 House Calls — On-site repair available at home or business</p>
                    <p style={lineStyle}>⚡ Emergency Repairs — Fast priority service when you need it most</p>
                </section>

                <section id="why" style={sectionStyle} data-aos="fade-up">
                    <h2 style={sectionHeader}>Why Choose Us?</h2>
                    <p style={lineStyle}>Veteran-Owned with a Passion for Service</p>
                    <p style={lineStyle}>Affordable, Honest, and Fast</p>
                    <p style={lineStyle}>Small Local Business</p>
                    <p style={lineStyle}>Giving Back to Our Community</p>
                </section>

                <section id="prices" style={sectionStyle} data-aos="fade-up">
                    <h2 style={sectionHeader}>Pricing</h2>
                    <p style={lineStyle}>Phone Screen Repair: Starting at $89</p>
                    <p style={lineStyle}>Battery Replacement: Starting at $49</p>
                    <p style={lineStyle}>iPad Repairs: Starting at $99</p>
                    <p style={lineStyle}>Open Phone Diagnostics $60</p>
                    <p style={lineStyle}>Computer Diagnostics $75</p>
                    <p style={lineStyle}>Custom Quotes Available — Contact Us</p>
                    <p style={lineStyle}>If device is repairable, diagnostics fee goes toward the repair.</p>
                </section>

                <section style={{ ...sectionStyle, backgroundColor: '#FA0057', borderRadius: '8px', marginTop: '40px' }} data-aos="zoom-in">
                    <h2 style={{ ...sectionHeader, color: '#FFD700' }}>Find Us Online</h2>
                    <p style={lineStyle}>
                        <a href="https://g.page/r/CVQ5LVISP_WgEAE/review" target="_blank" rel="noopener noreferrer" className="social-link">📍 Google Reviews</a>
                    </p>
                    <p style={lineStyle}>
                        <a href="https://www.facebook.com/profile.php?id=61576149508459" target="_blank" rel="noopener noreferrer" className="social-link">📘 Facebook</a>
                    </p>
                    <p style={lineStyle}>
                        <a href="https://www.instagram.com/cellphonesurgeons/" target="_blank" rel="noopener noreferrer" className="social-link">📸 Instagram</a>
                    </p>
                </section>

                <section id="contact" style={{ ...sectionStyle, backgroundColor: '#FC6629', borderRadius: '8px' }} data-aos="fade-up">
                    <h2 style={sectionHeader}>Contact Us</h2>
                    <p style={{ ...highlightText, fontSize: '26px' }}><strong>Address:</strong> 646 S Main St Unit B, Monroe, Ohio 45050</p>
                    <p style={lineStyle}><strong>Phone:</strong> <a href="tel:5135266836" style={linkStyle}>513-526-6836</a>, <a href="tel:5135161948" style={linkStyle}>513-516-1948</a></p>
                    <p style={lineStyle}><strong>Email:</strong> <a href="mailto:monroe@a1cellphonesurgeons.com" style={linkStyle}>monroe@a1cellphonesurgeons.com</a></p>
                    <div style={{ marginTop: '20px' }}>
                        <iframe
                            id="iframe_id"
                            src="https://master.d2b5wmh7w6ke13.amplifyapp.com/?frameId=NUpxYlhkQ1I0SDQvT0Q2YjltVEJ4YWtmTnAvLzduU25ld1IzMHBLdFBKdi9jVWdTano3NFhnOURNU2t0K2F6YS9uU2YvcnlaQ0F4UXBRdnFuMVhkblgrRGZYZ0NVWTcyeDJpNjlqaXdiYUEySkhsRjFOaHhXTUlDUnRwbjhtQitVZjcyN1ZKUEZTWDhoMzQ2OGZ2bGc3aWZFMDJxQTYrbXJydTV4eHhiZ1c3SVo1N1VsQ0oxcC8rY0Rhb0w2ekd6"
                            title="Repair Request Form"
                            width="100%"
                            height="700px"
                            style={{ border: 'none', background: 'transparent', borderRadius: '8px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}
                            allowFullScreen
                        ></iframe>
                    </div>
                </section>

                <footer style={{ marginTop: '60px', padding: '20px', backgroundColor: '#007ABD', textAlign: 'center', borderRadius: '8px', color: '#fff', fontSize: '20px' }}>
                    &copy; {new Date().getFullYear()} Cellphone Surgeons & Computer Repair. All rights reserved.
                </footer>
            </main>
        </>
    );
}

export default function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<MainPage />} />
                <Route path="/thank-you" element={<ThankYou />} />
            </Routes>
        </Router>
    );
}

const navStyle = { position: 'fixed', top: 0, left: 0, width: '100%', height: '0px', zIndex: 1000 };
const floatingMenuWrapper = { position: 'fixed', bottom: '20px', right: '20px', zIndex: 1001 };
const menuToggleStyle = { background: '#000', color: '#fff', fontSize: '26px', padding: '14px 26px', border: 'none', borderRadius: '50px', cursor: 'pointer', fontWeight: 'bold', boxShadow: '0 4px 12px rgba(0,0,0,0.3)' };
const dropdownMenuStyle = { position: 'absolute', bottom: '60px', right: '0px', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '5px', display: 'flex', flexDirection: 'column', zIndex: 1002 };
const dropdownBtnStyle = { padding: '12px 22px', background: 'none', border: 'none', textAlign: 'left', fontSize: '18px', cursor: 'pointer', width: '100%' };
const dropdownLinkStyle = { ...dropdownBtnStyle, color: '#000', textDecoration: 'none' };
const logoWrapperStyle = { textAlign: 'center', marginTop: '20px' };
const logoStyle = { maxWidth: '100%', height: 'auto', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.25)' };
const sectionStyle = { marginTop: '60px', padding: '20px' };
const sectionHeader = { fontSize: '40px', letterSpacing: '1.5px', marginBottom: '16px' };
const lineStyle = { fontSize: '26px', letterSpacing: '1px', margin: '16px 0' };
const linkStyle = { color: '#000', textDecoration: 'underline', fontSize: '22px' };
const highlightText = { fontSize: '24px' };
const inputStyle = { padding: '12px', borderRadius: '5px', border: '1px solid #aaa', fontSize: '18px' };
const submitBtnStyle = { backgroundColor: '#000', color: '#fff', padding: '14px', fontSize: '18px', borderRadius: '5px', border: 'none', cursor: 'pointer', fontWeight: 'bold' };
